import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { QueryFunction } from '@tanstack/react-query';

export interface MappingByTypeData {
  id: string;
  type: string;
  mapping: EFolderMappingData;
  createdAt: string;
  updatedAt: string;
}

export interface EFolderMappingData {
  filename: string;
  document_type: string;
  target_folder: string;
  id?: string;
}

export interface MappingsByTypeResponse {
  success: boolean;
  mappings: MappingByTypeData[];
}

const getMappingsByType: QueryFunction<
  EFolderMappingData[],
  ['/mappings/type', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<MappingsByTypeResponse>(
    `/mappings/${queryKey[1]}`,
    {
      method: 'GET',
    },
  );
  if (response.data) {
    return response.data.mappings.map((mapping) => ({
      id: mapping.id,
      filename: mapping.mapping.filename,
      document_type: mapping.mapping.document_type,
      target_folder: mapping.mapping.target_folder,
    }));
  }
  throw new Error('Failed to fetch mappings by type');
};

export default getMappingsByType;

// Mock data for development
const _mockData: EFolderMappingData[] = [
  {
    filename: 'Bank Statement',
    document_type: 'Bank Statement',
    target_folder: 'Assets - Bank Statements',
  },
  {
    filename: 'Credit Report',
    document_type: 'Credit Report',
    target_folder: 'Credit Report',
  },
];
